// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON = "Koupit";
